import type { BaseOrder } from '#domain/BaseOrder.ts';
import type { Stop } from '#domain/Stop.ts';

const canonicalServiceOrderTypes = [
    'cleaning',
    'parking',
    'fueling-or-charging',
    'assembly',
    'tour-start',
    'tour-end',
] as const;

export const serviceOrderTypes = [...canonicalServiceOrderTypes, 'other'] as const;

export type ServiceOrderType = (typeof serviceOrderTypes)[number];

export type ServiceOrder = BaseOrder & {
    type: 'service';
    executionStop: Stop;
    description: string;
    category?: ServiceOrderType;
    company?: string;
    note?: string;
};
